import { Inject, Injectable } from '@angular/core';
import { Response, Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';

import { SessionStorageService } from "./session-storage.service";

import { config } from "../../../../config/index";
import { UtilService } from './util.service';

@Injectable()
export class BaseWebService {

    constructor(
        private _http: Http,
        private _router: Router,
        private _sessionStorageService: SessionStorageService,
        @Inject('utilService') private utilService: any) {
    }

    /**
     * @param  {string} url contains url data passed from service
     * @param  {string} httpMethod contains the method used
     * @param  {any={}} data contains data passed with the service
     * @returns Observable
     */
    request = (url: string, httpMethod: string, data: any = {}): Observable<Response> => {
        return Observable.fromPromise(this.readToken())
            .map(tokenData => this.httpRequester(url, httpMethod, tokenData, data))
            .map(this.extractData)
            .catch((error: any) => this.handleError(error));
    }

    requestWithUrlToken = (url: string, httpMethod: string, data: any = {}): Observable<Response> => {
        let tokenData = {
            token: data.token
        }
        return this.httpRequester(url, httpMethod, tokenData, data)
            .map(this.extractData)
            .catch((error: any) => this.handleError(error));
    }

    requestFormDataWithUrlToken = (url: string, httpMethod: string, data: any): Observable<Response> => {
        let tokenData = {
            token: data.token
        }
        return this.httpRequesterFormData(url, httpMethod, tokenData, data)
            .map(this.extractData)
            .catch((error: any) => this.handleError(error));
    }

    requestWithoutToken = (url: string, httpMethod: string, data: any = {}): Observable<Response> => {
        return this.httpRequester(url, httpMethod, {}, data)
            .map(this.extractData)
            .catch((error: any) => this.handleError(error));
    }

    /**
     * @param  {string} url contains url data passed from service
     * @param  {string} httpMethod contains the method used
     * @param  {any} data data contains data passed with the service
     * @returns Observable
     */
    requestFormData = (url: string, httpMethod: string, data: any): Observable<Response> => {
        return Observable.fromPromise(this.readToken())
            .map(tokenData => this.httpRequesterFormData(url, httpMethod, tokenData, data))
            .map(this.extractData)
            .catch((error: any) => this.handleError(error));
    }

    requestFormDataWithoutToken = (url: string, httpMethod: string, data: any): Observable<Response> => {
        return this.httpRequesterFormData(url, httpMethod, {}, data)
            .map(this.extractData)
            .catch((error: any) => this.handleError(error));
    }

    /**
     * @param  {string} url contains url data passed from service
     * @param  {string} httpMethod contains the method used
     * @param  {any={}} tokenData contains authorization token
     * @param  {any={}} data contains data passed with the service
     */
    private httpRequester = (url: string, httpMethod: string, tokenData: any = {}, data: any = {}) => {
        httpMethod = httpMethod.toLowerCase();
        tokenData.token = "" + tokenData.token;
        const defaultHeaders = { 'Content-Type': 'application/json', 'VC-API-Token': tokenData.token };
        const requestHeaders = new Headers({ ...defaultHeaders, ...data.headers });
        const params = [];
        params.push(config.baseUrl + url);
        if (httpMethod !== 'get' && httpMethod !== 'delete') params.push(data.body);
        params.push({ headers: requestHeaders });
        return this._http[httpMethod](...params);
    }

    /**
     * @param  {string} url contains url data passed from service
     * @param  {string} httpMethod contains the method used
     * @param  {any={}} tokenData contains authorization token
     * @param  {any} data contains data passed with the service
     */
    private httpRequesterFormData = (url: string, httpMethod: string, tokenData: any = {}, data: any) => {
        httpMethod = httpMethod.toLowerCase();
        tokenData.token = "" + tokenData.token;
        const defaultHeaders = { 'VC-API-Token': tokenData.token };
        const requestHeaders = new Headers({ ...defaultHeaders, ...data.headers });
        const params = [];
        params.push(config.baseUrl + url);
        if (httpMethod !== 'get' && httpMethod !== 'delete') params.push(data.body);
        params.push({ headers: requestHeaders });
        return this._http[httpMethod](...params);
    }

    /**
     * This function reads token stored in focalStorage
     */
    private readToken = () => {
        return this._sessionStorageService.readItem(config.storage_key)
            .then(response => {
                if (response === null) response = {};
                return response;
            })
            .catch(this.handleTokenError);
    }

    /**
     * Function to extract response from service call
     * @param  {Response} res
     */
    private extractData = (res: any) => {
        var body;
        try {
            var body = res.json();
        }
        catch (err) {
            var body = res._body;
        }
        if (res.status === 200 || res.status === 201) {
            return body || {};
        }
        else {
            throw body.message;
        }
    }

    /**
     * Function to handle service call errors
     * @param  {Response|any} error
     */
    private handleError = (error: Response | any) => {
        let status = error.status;
        const body = error.json();
        let errMsg: string;

        if (status === 402) {
            this.utilService.restrictAccess.next({
                restrict: true,
                phone: body.primary_location_contact_number,
                email: body.primary_location_email,
                country_key: body.country_key
            });
        } else if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        throw body;
    }

    private handleTokenError = (error: Response | any) => {
        console.log("token error handle");
    }

}